import React from 'react';
import propTypes from 'prop-types';

import Canvas from 'app/Canvas/components/Canvas';
import Explorer from 'app/Explorer/container';
import UnsavedChangesConfirmationModal from 'app/UnsavedChangesConfirmationModal/container';
import UserInfo from 'app/UserInfo/container';

import { PAGE_TEMPLATES } from '../const';
import styles from './CanvasApp.css';
import Editor from './Editor';

/**
 * the main ui view
 * @param {object} props - props passed to this component
 * @param {string} props.applicationMode - the application mode
 * @returns {React.Component} the main ui view
 */
const CanvasApp = ({ applicationMode }) => (
  <div className="d-flex flex-column w-100">
    <UnsavedChangesConfirmationModal />
    <UserInfo />
    <div className={styles.app}>
      <Explorer />
      <Canvas />
      <Editor applicationMode={applicationMode} />
    </div>
  </div>
);

CanvasApp.propTypes = {
  applicationMode: propTypes.string
};
CanvasApp.defaultProps = {
  applicationMode: PAGE_TEMPLATES
};

export default CanvasApp;
